
import { createSelector } from 'reselect';
import { IFacilityShiftCreateState, IWorkerSuggestionsState, IFacilityShiftUpdateState, IFacilityShiftDetailsState, IAssignWorkersState, IShiftExtensionState, IDeleteCancelledShiftState } from './types';

const selectFacilityShiftCreateState = (state: { facilityShiftCreate: IFacilityShiftCreateState }) => state.facilityShiftCreate;

export const selectFacilityShiftCreateLoading = createSelector(
  selectFacilityShiftCreateState,
  (facilityShiftCreateState) => facilityShiftCreateState.loading
);

export const selectFacilityShiftCreateData = createSelector(
  selectFacilityShiftCreateState,
  (facilityShiftCreateState) => facilityShiftCreateState.data
);

export const selectFacilityShiftCreateError = createSelector(
  selectFacilityShiftCreateState,
  (facilityShiftCreateState) => facilityShiftCreateState.error
);

export const selectFacilityShiftCreateMessage = createSelector(
  selectFacilityShiftCreateState,
  (facilityShiftCreateState) => facilityShiftCreateState.message
);

const selectFacilityShiftUpdateState = (state: { facilityShiftUpdate: IFacilityShiftUpdateState }) => state.facilityShiftUpdate;

export const selectFacilityShiftUpdateLoading = createSelector(
  selectFacilityShiftUpdateState,
  (state) => state.loading
);

export const selectFacilityShiftUpdateData = createSelector(
  selectFacilityShiftUpdateState,
  (state) => state.data
);

export const selectFacilityShiftUpdateError = createSelector(
  selectFacilityShiftUpdateState,
  (state) => state.error
);

export const selectFacilityShiftUpdateMessage = createSelector(
  selectFacilityShiftUpdateState,
  (state) => state.message
);

const selectShiftDetailsState = (state: { facilityShiftDetails: IFacilityShiftDetailsState }) => state.facilityShiftDetails;

export const selectShiftDetailsLoading = createSelector(
  selectShiftDetailsState,
  (state) => state.loading
);

export const selectShiftDetailsData = createSelector(
  selectShiftDetailsState,
  (state) => state.data
);

export const selectShiftDetailsError = createSelector(
  selectShiftDetailsState,
  (state) => state.error
);

const selectWorkerSuggestionsState = (state: { workerSuggestions: IWorkerSuggestionsState }) => state.workerSuggestions;

export const selectWorkerSuggestionsLoading = createSelector(
  selectWorkerSuggestionsState,
  (workerSuggestionsState) => workerSuggestionsState.loading
);

export const selectWorkerSuggestionsData = createSelector(
  selectWorkerSuggestionsState,
  (workerSuggestionsState) => workerSuggestionsState.data
);

export const selectWorkerSuggestionsError = createSelector(
  selectWorkerSuggestionsState,
  (workerSuggestionsState) => workerSuggestionsState.error
);

export const selectWorkerSuggestionsTotalWorkers = createSelector(
  selectWorkerSuggestionsState,
  (workerSuggestionsState) => workerSuggestionsState.total_workers
);

const selectAssignWorkersState = (state: { assignWorkers: IAssignWorkersState }) => state.assignWorkers;

export const selectAssignWorkersLoading = createSelector(
  selectAssignWorkersState,
  (state) => state.loading
);

export const selectAssignWorkersSuccess = createSelector(
  selectAssignWorkersState,
  (state) => state.success
);

export const selectAssignWorkersError = createSelector(
  selectAssignWorkersState,
  (state) => state.error
);

const selectShiftExtensionState = (state: { shiftExtension: IShiftExtensionState }) => state.shiftExtension;

export const selectShiftExtensionExtending = createSelector(
  selectShiftExtensionState,
  (state) => state.extending
);

export const selectShiftExtensionValidating = createSelector(
  selectShiftExtensionState,
  (state) => state.validating
);

export const selectShiftExtensionValidationConflicts = createSelector(
  selectShiftExtensionState,
  (state) => state.validationConflicts
);

export const selectShiftExtensionValidationError = createSelector(
  selectShiftExtensionState,
  (state) => state.validationError
);

export const selectShiftExtensionError = createSelector(
  selectShiftExtensionState,
  (state) => state.extensionError
);

export const selectShiftExtensionSuccess = createSelector(
  selectShiftExtensionState,
  (state) => state.extensionSuccess
);

export const selectShiftExtensionValidationSuccess = createSelector(
  selectShiftExtensionState,
  (state) => state.validationSuccess
);

// Past Shift Selectors
const selectFacilityShiftPastCreateState = (state: { facilityShiftPastCreate: IFacilityShiftCreateState }) => state.facilityShiftPastCreate;
const selectFacilityShiftPastUpdateState = (state: { facilityShiftPastUpdate: IFacilityShiftUpdateState }) => state.facilityShiftPastUpdate;

export const selectPastFacilityShiftCreateLoading = createSelector(
  selectFacilityShiftPastCreateState,
  (state) => state.loading
);
export const selectPastFacilityShiftCreateData = createSelector(
  selectFacilityShiftPastCreateState,
  (state) => state.data
);
export const selectPastFacilityShiftCreateError = createSelector(
  selectFacilityShiftPastCreateState,
  (state) => state.error
);
export const selectPastFacilityShiftCreateMessage = createSelector(
  selectFacilityShiftPastCreateState,
  (state) => state.message
);

export const selectPastFacilityShiftUpdateLoading = createSelector(
  selectFacilityShiftPastUpdateState,
  (state) => state.loading
);
export const selectPastFacilityShiftUpdateData = createSelector(
  selectFacilityShiftPastUpdateState,
  (state) => state.data
);
export const selectPastFacilityShiftUpdateError = createSelector(
  selectFacilityShiftPastUpdateState,
  (state) => state.error
);
export const selectPastFacilityShiftUpdateMessage = createSelector(
  selectFacilityShiftPastUpdateState,
  (state) => state.message
);

const selectDeleteCancelledShiftState = (state: { deleteCancelledShift: IDeleteCancelledShiftState }) => state.deleteCancelledShift;

export const selectDeleteCancelledShiftLoading = createSelector(
  selectDeleteCancelledShiftState,
  (state) => state.loading
);

export const selectDeleteCancelledShiftSuccess = createSelector(
  selectDeleteCancelledShiftState,
  (state) => state.success
);

export const selectDeleteCancelledShiftError = createSelector(
  selectDeleteCancelledShiftState,
  (state) => state.error
);

export const selectDeleteCancelledShiftMessage = createSelector(
  selectDeleteCancelledShiftState,
  (state) => state.message
);
